/*
 * @Author: zhangjiangpo
 * @Date: 2023-08-30 13:59:51
 * @LastEditors: zhangjiangpo
 * @LastEditTime: 2024-07-25 14:37:13
 * @Description:
 */
import { RIGHT_PACKAGE_TYPE } from '../constants'
import moment from 'moment'

const getNum = val => {
  if (val === 0) return 0
  return val || '--'
}

export const columns = [
  {
    title: '权益类型',
    dataIndex: 'cardType',
    key: 'cardType',
    customRender: (text, row) => RIGHT_PACKAGE_TYPE[text] || '--'
  },
  {
    title: '来源',
    dataIndex: 'orderType',
    key: 'orderType',
    customRender: (text, row) => (text === 1 ? '购买' : '赠送')
  },
  {
    title: '发放时间',
    dataIndex: 'createTime',
    key: 'createTime',
    customRender: (text, row) => moment(text).format('YYYY/MM/DD HH:mm:ss') || '--'
  },
  {
    title: '发放数量',
    dataIndex: 'buyNumber',
    key: 'buyNumber',
    customRender: (text, row) => getNum(text)
  },
  {
    title: '已使用数量',
    dataIndex: 'consumerNumber',
    key: 'consumerNumber',
    customRender: (text, row) => getNum(text)
  },
  {
    title: '可用数量',
    dataIndex: 'residueNumber',
    key: 'residueNumber',
    customRender: (text, row) => getNum(text)
  },
  {
    title: '近30天到期数量',
    dataIndex: 'expireNumberSoon',
    width: 120,
    key: 'expireNumberSoon',
    scopedSlots: { customRender: 'expireNumberSoon' }
  },
  {
    title: '到期时间',
    sorter: true,
    dataIndex: 'expireTime',
    key: 'expireTime',
    customRender: (text, row) => ((row.cardType !== 18 && moment(text).format('YYYY/MM/DD HH:mm:ss')) || '--')
  },
  {
    title: '到期数量',
    dataIndex: 'expireNumber',
    key: 'expireNumber',
    customRender: (text, row) => (row.cardType !== 18 ? getNum(text) : '--')
  },
  {
    title: '冻结数量',
    dataIndex: 'blockNumber',
    key: 'blockNumber',
    customRender: (text, row) => getNum(text)
  },
  {
    title: '已退数量',
    dataIndex: 'backNumber',
    key: 'backNumber',
    customRender: (text, row) => getNum(text)
  }
]